import trans from 'translate';
import { getValueByMultiProps } from './mapper';

export const formatTokenName = (token, nameProps = ['token_name', 'name']) => {
  const name = getValueByMultiProps(token, nameProps) || '';
  return name.toLowerCase().replaceAll(' ', '-');
};

export const isRequiredMsg = (fieldName) => trans('fields.is_required', { fieldName });

export const renderCoin = (value, coin = '$') => `${coin}${value}`;

export const formatTxHash = (txHash = '') => ({
  showed: [txHash?.substring?.(0, 4), txHash?.substring?.(txHash?.length - 5, txHash?.length)].join('...'),
  fullString: txHash,
});

export const handleEmptyId = (translated = '', original) => (translated === 'empty - id' ? original : translated);

export const getTokenSymbol = (token = {}) => {
  const symbolKeys = ['symbol', 'token_symbol'];
  const symbol = getValueByMultiProps(token, symbolKeys) || '';
  return symbol.toLowerCase();
};

/* interface ILoadingMsg {
  isLoading: Boolean;
  loadingText: string;
} */

export const combineLoadingMsgs = (loadingMsgs = []) => {
  const currentLoading = loadingMsgs.find((loadingMsg) => loadingMsg.isLoading);
  return currentLoading || {};
};

export const parseLocalStrings = (stringNumber = '') => {
  if (typeof stringNumber === 'number') return stringNumber;
  let result = stringNumber;
  if (stringNumber.includes(',')) result = result.replaceAll(',', '');
  return +result;
};

const hanldeDigits = (value = '') => value.split('.');

export const formatNumericValues = (value = '') => {
  if (!value) return '';
  if (value?.includes?.('.')) {
    const [numberValue, afterDigit] = hanldeDigits(value);
    return [formatNumericValues(numberValue), afterDigit].join('.');
  }
  const result = (+parseLocalStrings(value)).toLocaleString() || '';
  return result;
};
